
import { Doughnut, mixins } from 'vue-chartjs';
import 'chartjs-plugin-labels';
const { reactiveProp } = mixins;

Chart.defaults.global.plugins.labels = {
  render: (args) => {
    if (args.percentage >= 4) {
      return args.value;
    } else {
      return '';
    }
  },
  fontColor: '#ffffffff',
  fontStyle: 'bold',
  fontSize: 14,
};

export default { extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted() {
    this.determineTextColour();
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    determineTextColour() {
      const isMobile = this.$q.screen.width <= 768;
      if (isMobile) {
        Chart.defaults.global.plugins.labels.fontColor = '#ffffff00';
      } else {
        Chart.defaults.global.plugins.labels.fontColor = '#ffffffff';
      }
    },
  },
};
